<template>
     <p class="py-1 mb-0 d-flex align-items-center">
      <i class="fas fa-landmark me-2 text-success"></i> 
        {{ seccionPresupuestalVigencia }} &nbsp;<i class="fas fa-calendar-alt me-2 text-success"></i>
       Vigencia:  {{ vigencia }} 
     </p>
</template>

<script setup>
import { useAuthStore } from '@/stores/auth.js';
import { computed } from 'vue'

const auth = useAuthStore()

const vigencia = computed(() => auth.vigencia.vigencia)
const seccionPresupuestalVigencia = computed(() => auth.seccionPresupuestal.seccion)
</script>